// Downloads Sort By Buttons
// Toggle-style: None (default), Most recent, Popular, Most downloaded, Hot
// Default = no sort (pinned items first). Click to select; click active again to deselect.

import './DownloadsSortByButtons.css';

const SORT_OPTIONS = [
  { value: 'most-recent', label: 'Most recent' },
  { value: 'most-viewed', label: 'Most viewed' },
  { value: 'most-downloaded', label: 'Most downloaded' },
  { value: 'hot', label: 'Hot' },
];

export function DownloadsSortByButtons({ value, onChange, className = '' }) {
  return (
    <div className={`downloads-sort-by-buttons ${className}`} role="group" aria-label="Sort by">
      {SORT_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`downloads-sort-by-btn ${value === opt.value ? 'is-active' : ''}`}
          onClick={() => onChange?.(value === opt.value ? '' : opt.value)}
          aria-pressed={value === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
